import ReportGenerator from "./report_generator";
import {
    AREA_DATA_FIELD,
    BUILDING_DATA_FIELD,
    CHANGES_IN_LAST_TWO_WEEKS_REPORT_TITLE,
    COST_DATA_FIELD,
    COUNT_FIELD,
    DEPLOYMENT_STATUS_FIELD,
    LINE_CHART,
    ROOM_DATA_FIELD,
    TOTAL_COST_FIELD,
    UPDATED_AT_DATA_FIELD
} from "../../constants/reports_constants";

export default class ChangesInLastTwoWeeksReportGenerator extends ReportGenerator {

    _getGraphTitle() {
        return CHANGES_IN_LAST_TWO_WEEKS_REPORT_TITLE;
    }

    _hideUnusedColumns() {
        this._hideColumn(BUILDING_DATA_FIELD);
        this._hideColumn(COST_DATA_FIELD);
        this._hideColumn(COUNT_FIELD);
        this._hideColumn(DEPLOYMENT_STATUS_FIELD);
        this._hideColumn(TOTAL_COST_FIELD);
    }

    _showUsedColumns() {
        this._showColumn(AREA_DATA_FIELD);
        this._showColumn(ROOM_DATA_FIELD);
        this._showColumn(UPDATED_AT_DATA_FIELD);
    }

    _getChartType() {
        return LINE_CHART;
    }

}